<template>
  <div class="event-detail-header">
    <span class="event-detail-header__date">
      <span data-testid="event-date">{{timestamp.date}}</span>
      <span class="ml-3" data-testid="event-time">{{timestamp.time}}</span>
    </span>
    <span class="event-detail-header__count" v-if="count">{{count}}</span>
  </div>
</template>

<script>
import DateTimeFormatting from '@/mixins/dateTimeFormatting';

export default {
  name: 'event-detail-header',
  mixins: [DateTimeFormatting],
  props: ['event'],
  computed: {
    count() {
      return this.event.count;
    },
    timestamp() {
      return {
        date: this.formatDate(this.event.timestamp),
        time: this.formatTime(this.event.timestamp),
      };
    },
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.event-detail-header
  background-color: map-get($colors, 'grey', 'darken-2')
  color: white
  font-size: 13px
  padding: 0 $spacer
  display: flex
  align-items: center

  &__date
    flex-grow: 1
</style>
